import React from "react";
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import LoadingSpinner from "@/components/LoadingSpinner";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { AdminsKeys, getAdmins } from "@/features/admins/api/admins";

interface AdminsTableProps {
  setAdminId: (id: string) => void;
}

const AdminsTable: React.FC<AdminsTableProps> = ({ setAdminId }) => {
  const { data = [], isLoading } = useQuery({
    queryKey: [AdminsKeys.GET_ADMINS],
    queryFn: getAdmins,
  });

  if (isLoading) {
    return (
      <Card className="p-8 flex items-center justify-center">
        <LoadingSpinner />
      </Card>
    );
  }

  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Created At</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((admin) => (
            <TableRow
              key={admin._id}
              className="cursor-pointer"
              onClick={() => setAdminId(admin._id)}
            >
              <TableCell>{`${admin.firstName} ${admin.lastName}`}</TableCell>
              <TableCell>{admin.email}</TableCell>
              <TableCell>
                {format(new Date(admin.createdAt), "dd/MM/yyyy")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default AdminsTable;
